import * as React from 'react';
import { ColorProps, color } from 'styled-system';
import { BreadcrumbsLinkItem } from '@packages/common';
import styled from 'styled-components';
import { Anchor } from '../primitives';
import { themeGet } from '../../theme/utils';

export const BreadcrumbsList = styled.ul`
  list-style: none;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  display: flex;
  flex-direction: row;
`;

export const BreadcrumbsListItem = styled.li`
  font-size: ${themeGet.fontSize(4)};
  color: ${themeGet.colors('kilamanjaro')};
  &:last-child {
    color: ${themeGet.colors('sandDune')};
  }
`;

export interface BreadcrumbsProps {
  breadcrumbs: BreadcrumbsLinkItem[] | string;
  className?: string;
}

export const Divider = styled.span.attrs({
  children: '|',
})<{ color?: ColorProps }>`
  margin-left: ${themeGet.space(3)};
  margin-right: ${themeGet.space(3)};
  font-size: ${themeGet.fontSize(6)};
  ${color}
`;

Divider.defaultProps = {
  color: `${themeGet.colors('kilamanjaro')}`,
};

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ className, breadcrumbs }) => {
  if (!breadcrumbs || breadcrumbs.length <= 0) {
    return <></>;
  }

  return (
    <BreadcrumbsList className={className}>
      {Array.isArray(breadcrumbs) ? (
        breadcrumbs.map(({ title, url }, idx) => {
          const isLast = idx >= breadcrumbs.length - 1;
          return (
            <BreadcrumbsListItem key={`breadcrumb-${idx}`}>
              {isLast ? (
                title
              ) : (
                <>
                  <Anchor href={url}>{title}</Anchor> <Divider />
                </>
              )}
            </BreadcrumbsListItem>
          );
        })
      ) : (
        <BreadcrumbsListItem>{breadcrumbs}</BreadcrumbsListItem>
      )}
    </BreadcrumbsList>
  );
};
